import React from "react"
import PropTypes from "prop-types"
import OnVisible from "react-on-visible"
import "../css/simple-slider.css"

var timeOut;

class SimpleSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: 0,
    }
  }

  handleActive() {

    if(timeOut){
      clearTimeout(timeOut);
    }
    timeOut = setTimeout(() => {
      this.state.active < this.props.children.length - 1
        ? this.setState({
            active: this.state.active + 1,
          })
        : this.setState({ active: 0 })
    }, 5000)
   // console.log("active", this.state.active)
    //return timer
  }

  handleClick(index) {
   
    clearTimeout(timeOut);
    this.setState({
      active: index,
    })

    this.handleActive()
  }

  handleImages() {
    var current = this
    return current.props.children.map(function (child, index) {
      return (
        <div className={index == current.state.active && "active"}>
          {" "}
          {child.props.image}
        </div>
      )
    })
  }

  handleText() {
    var current = this
    return current.props.children.map(function (child, index) {
      return (
        <div
          onClick={() => {
            current.handleClick(index)
          }}
          className={index == current.state.active && "active"}
        >
          {" "}
          {child.props.text}
        </div>
      )
    })
  }

  render() {
    var current = this

    this.handleActive()
    return (
      <OnVisible className="simple-slider-wrapper">
        {}
        <div className="images-wrapper">{this.handleImages()}</div>
        <div className="text-wrapper">{this.handleText()}</div>
      </OnVisible>
    )
  }
}

SimpleSlider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SimpleSlider
